import { IClientCityBrief } from '@bustickus/models-client';
import { getCityByName, getCityByIndex } from '.';

function getCityDeparture(initCityId: string | null, cities: IClientCityBrief[]): IClientCityBrief | null {
  if (initCityId != null) {
    const city = cities.find((x) => x.id == initCityId);

    if (city != null) {
      return city;
    }
  }

  let city = getCityByName(cities, 'Чита');

  if (city == null) {
    city = getCityByIndex(cities, 0);
  }

  return city;
}

export default getCityDeparture;
